<div>
  <h1>{{ title }}</h1>
  @if (manual) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-description>Referenz</mat-panel-description>
      </mat-expansion-panel-header>
      <div [innerHTML]="manual"></div>
    </mat-expansion-panel>
  }
  <form class="input-form" [formGroup]="form">
    <table class="mat-elevation-z8">
      <thead>
        <th class="head-left">
          @if (!manual) {
            <mat-checkbox
              class="example-margin"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="showManual"
              labelPosition="after">
              Bewertungsschlüssel einblenden
            </mat-checkbox>
          }
        </th>
        <th class="input-column head">Wert</th>
      </thead>
      <tbody>
        @for (row of dataHtml; track row.name) {
          <tr>
            <td>
              <h3>{{ row.label }}</h3>
              @if (showManual && !manual) {
                <p class="task-info" [innerHTML]="row.taskInfo"></p>
              }
            </td>
            <td class="input-column">
              <div class="input">
                <input
                  [ngClass]="{ 'input-error': form.status === 'INVALID' }"
                  [tabIndex]="startTabIndex + $index"
                  [formControlName]="row.controlMidName"
                  type="number"
                  appNumbersOnly
                  placeholder="" />
                @if (form.controls[row.controlMidName].invalid) {
                  <mat-icon class="input-icon mat-mdc-form-field-error">error</mat-icon>
                }
              </div>
              @if (form.controls[row.controlMidName].hasError('max')) {
                <mat-error class="input-error">Wert zu groß</mat-error>
              }
              @if (form.controls[row.controlMidName].hasError('min')) {
                <mat-error class="input-error">Wert zu klein</mat-error>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
    <!-- <mat-form-field class="note">
      <mat-label>Zusätzliche Hinweise (optional)</mat-label>
      <textarea
        [tabIndex]="startTabIndex + dataHtml.length * 2 + 1"
        type="text"
        matInput
        formControlName="note"
        placeholder=""></textarea>
    </mat-form-field> -->
  </form>
</div>
